import { z } from 'zod'

// deleting the account destroys every record it owns, so the access token alone is not enough:
// the caller proves they know the password, exactly as for a password change
export const deleteAccountSchema = z.object({
  currentPassword: z.string().min(1, 'Current password is required'),
})

export type DeleteAccountDto = z.infer<typeof deleteAccountSchema>
